import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Type, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { takeUntil } from "rxjs/operators";
import { GoodsFormulaDetail, GoodsFormulaHeader, GoodsSimilar } from "../../../models/goods-formula-detail.model";
import { Goods } from "../../../models/goods.model";
import { GoodsFormulaFormComponent } from "../goods-formula-form/goods-formula-form.component";

@Component({
  selector: "ngx-goods-similar-form",
  templateUrl: "./goods-similar-form.component.html",
  styleUrls: ["./goods-similar-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoodsSimilarFormComponent extends BaseFormComponent<Goods> {
  @Input() GoodsSimilarColumns: form_control[] = [];
  @Input() CurrentGoodsFormulaDetail: GoodsFormulaDetail;
  @Input() CurrentGoodsFormulaHeader: GoodsFormulaHeader;
  @Input() GoodsSimilars: GoodsSimilar[] = [];
  @ViewChild("goodsSimilar") public goodsSimilar: KGridComponent;
  inputEditorform: Type<any>;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.inputEditorform = GoodsFormulaFormComponent;
  }
  async ngOnInit() {
    this.noLoadData = true;
    this.model = Object.assign({}, this.currentrow);
    super.ngOnInit();
    this.setFormGroup(this.model);
  }
  addControl() {
    this.cd.markForCheck();
  }
  onCreateGoodsSimilar($event: GoodsSimilar) {
    if (!this.CurrentGoodsFormulaDetail && this.CurrentGoodsFormulaHeader.GoodsFormulaDetails.length === 1)
      this.CurrentGoodsFormulaDetail = this.CurrentGoodsFormulaHeader.GoodsFormulaDetails[0];

    if (!this.CurrentGoodsFormulaDetail) this.sts.showDialog("اجزاء تشکیل دهنده کالا انتخاب نشده است.", "");

    if (!this.CurrentGoodsFormulaDetail.GoodsSimilars) this.CurrentGoodsFormulaDetail.GoodsSimilars = [];
    if (!this.GoodsSimilars) this.GoodsSimilars = [];
    $event = <GoodsSimilar>{};
    $event.GoodsFormulaDetailId = this.CurrentGoodsFormulaDetail.Id ?? 0;
    $event.PriceRatio = 1;
    $event.LossPercent = 0;
    $event.StandardAmount = this.CurrentGoodsFormulaDetail.StandardAmount ?? 0;
    $event.LossAmount = 0;
    $event.Priority = this.GoodsSimilars.length + 1;
    $event.State = RowState.New;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: $event,
          _columns: this.GoodsSimilarColumns,
          areaName: this.areaName,
          label: `کالای مشابه (${this.CurrentGoodsFormulaDetail?.GoodsTitle})`,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          this.model.GoodsFormulaHeaders.forEach((x) => {
            if (x.GoodsFormulaDetails.some((s) => s.GoodsId === model["GoodsId"])) {
              this.sts.showDialog(`مواد اولیه (${model["GoodsTitle"]})  نمی تواند به عنوان کالای مشابه انتخاب شود.`, "خطای انتخاب کالا");
              return;
            }
            x.GoodsFormulaDetails.forEach((gfd) => {
              if (
                (gfd.Id && gfd.Id !== 0 && gfd.Id === this.CurrentGoodsFormulaDetail.Id) ||
                (this.CurrentGoodsFormulaDetail.TempRowNumber && gfd.TempRowNumber == this.CurrentGoodsFormulaDetail.TempRowNumber)
              ) {
                if (!gfd.GoodsSimilars) gfd.GoodsSimilars = [];
                gfd.GoodsSimilars.push(model as GoodsSimilar);
                this.GoodsSimilars = gfd.GoodsSimilars;
                this.goodsSimilar.isRefreshing = true;
                this.goodsSimilar.refreshData();
                this.cd.markForCheck();
              }
            });
          });
        }
      });
  }
  onDeleteGoodsSimilar($event) {
    this.sts.showDialog(
      `آیا از حذف کالا اطمینان دارید؟`,
      this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.DeleteInformation"),
      DialogType.confirm,
      async () => {
        this.model.GoodsFormulaHeaders.forEach((gfh) => {
          gfh.GoodsFormulaDetails.forEach((gfd) => {
            gfd.GoodsSimilars.forEach((gs) => {
              if (
                (gs.GoodsId && gs.GoodsId !== 0 && gs.GoodsId === $event.GoodsId) ||
                ($event.TempRowNumber && gs.TempRowNumber == $event.TempRowNumber)
              ) {
                if (gs.State === RowState.New) gs.State = RowState.Detached;
                else gs.State = RowState.Delete;
                this.goodsSimilar.isRefreshing = true;
                this.goodsSimilar.refreshData();
                this.cd.markForCheck();
              }
            });
          });
        });
      }
    );
  }
  onEditGoodsSimilar($event: GoodsSimilar) {
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: $event,
          _columns: this.GoodsSimilarColumns,
          areaName: this.areaName,
          label: `کالای مشابه (${this.CurrentGoodsFormulaDetail?.GoodsTitle})`,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          (model as GoodsSimilar).State = RowState.Modify;
          (model as GoodsSimilar).LossAmount = ((model as GoodsSimilar).StandardAmount * (model as GoodsSimilar).LossPercent) / 100;
          this.model.GoodsFormulaHeaders.forEach((x) => {
            if (x.GoodsFormulaDetails.some((s) => s.GoodsId === model["GoodsId"])) {
              this.sts.showDialog(`مواد اولیه (${model["GoodsTitle"]})  نمی تواند به عنوان کالای مشابه انتخاب شود.`, "خطای انتخاب کالا");
              return;
            }
            x.GoodsFormulaDetails.forEach((gfd) =>
              gfd.GoodsSimilars.forEach((gs) => {
                if ((gs.TempRowNumber && gs.TempRowNumber === $event.TempRowNumber) || (gs.Id && gs.Id !== 0 && gs.Id === $event.Id)) {
                  Object.assign(gs, model);
                  this.goodsSimilar.isRefreshing = true;
                  this.goodsSimilar.refreshData();
                  this.cd.markForCheck();
                }
              })
            );
          });
        }
      });
  }
  async save() {
    if (this.formGroup?.valid) {
      this.result = this.getDataFromFormGroup();
      this.closeModal();
    }
  }
  cancel() {
    this.closeModal();
  }
}
